import CreateOrganizationButtonView from "./CreateOrganizationButtonView";

/**
 * Container component for the create organization button.
 * Provides wrapper for the button view component.
 */
const CreateOrganizationButtonContainer = () => {
  return <CreateOrganizationButtonView />;
};

export default CreateOrganizationButtonContainer;
